/* Climat72 · поведение общих блоков. Собрано из design\src (_base.js). Править там, затем: python src\export_shopify.py */
/* Поведение макета: язык, мобильное меню, список для сметы, сравнение, подбор мощности.
   Без библиотек. В теме Shopify разойдётся по assets/c72-*.js; язык там переключает сам Shopify. */
(function () {
  var root = document.documentElement;
  root.classList.add('js');
  var KEY = 'c72-mockup-lang';
  var each = function (sel, fn, scope) { Array.prototype.forEach.call((scope || document).querySelectorAll(sel), fn); };
  var lang = function () { return String(root.lang).slice(0, 2) === 'en' ? 'en' : 'fr'; };
  var fmt = function (n) { return new Intl.NumberFormat(lang() === 'fr' ? 'fr-CA' : 'en-CA').format(n); };

  /* --- Язык: FR по умолчанию; ?lang=en в адресе нужен для скриншотов --- */
  function setLang(next, save) {
    if (next !== 'fr' && next !== 'en') return;
    root.lang = next;
    each('[data-set-lang]', function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-set-lang') === next)); });
    each('[data-al-' + next + ']', function (e) { e.setAttribute('aria-label', e.getAttribute('data-al-' + next)); });
    each('[data-ph-' + next + ']', function (e) { e.setAttribute('placeholder', e.getAttribute('data-ph-' + next)); });   // подсказка в поле ввода
    each('option[data-' + next + ']', function (o) { o.textContent = o.getAttribute('data-' + next); });                  // пункты выпадающего списка
    var title = root.getAttribute('data-title-' + next);
    if (title) document.title = title;
    if (save) { try { localStorage.setItem(KEY, next); } catch (e) { /* хранилище недоступно: не страшно */ } }
    each('[data-sizing]', updateSizing);
    document.dispatchEvent(new CustomEvent('c72:lang'));   // страница товара перерисовывает числа в формате языка
  }

  /* --- Подбор мощности (схематично): 25 BTU/ч на кв. фут, округление вверх до продаваемой мощности --- */
  var CAPS = [9000, 12000, 18000, 24000, 30000, 36000, 42000, 48000, 60000];
  var SINGLE_WALL_MAX = 24000;
  function updateSizing(box) {
    var input = box.querySelector('[data-area]');
    if (!input) return;
    var sqft = Number(input.value);
    var min = Number(input.min), max = Number(input.max);
    var btu = sqft * 25;
    var cap = CAPS[CAPS.length - 1];
    for (var i = 0; i < CAPS.length; i++) { if (CAPS[i] >= btu) { cap = CAPS[i]; break; } }
    var set = function (sel, text) { each(sel, function (e) { e.textContent = text; }, box); };
    set('[data-out-sqft]', fmt(sqft));
    set('[data-out-m2]', fmt(Math.round(sqft / 10.7639)));
    set('[data-out-btu]', fmt(cap));
    box.style.setProperty('--c72-p', ((sqft - min) / (max - min)).toFixed(3));
    each('[data-cap]', function (e) { e.classList.toggle('is-on', Number(e.getAttribute('data-cap')) === cap); }, box);
    each('[data-multi-hint]', function (e) { e.hidden = cap <= SINGLE_WALL_MAX; }, box);
    each('[data-preset]', function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-preset')) === sqft)); }, box);
  }

  /* --- Список для сметы и сравнение: в макете только счётчик и состояние кнопок.
         Считаются нажатые кнопки «в список» и строки списка на страницах списка и запроса (data-list-item). --- */
  function updateList() {
    var n = document.querySelectorAll('[data-add][aria-pressed="true"],[data-list-item]:not([hidden])').length;
    each('[data-list-count]', function (e) { e.textContent = String(n); });
  }
  document.addEventListener('c72:quote-list-change', updateList);   // то же событие шлёт модуль logic\c72-quote-list.js

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-set-lang],[data-nav-toggle],[data-add],[data-compare],[data-preset]');
    if (!t) return;
    if (t.hasAttribute('data-set-lang')) { setLang(t.getAttribute('data-set-lang'), true); return; }
    if (t.hasAttribute('data-nav-toggle')) {
      var open = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', String(open));
      var nav = document.getElementById(t.getAttribute('aria-controls'));
      if (nav) nav.classList.toggle('is-open', open);
      return;
    }
    if (t.hasAttribute('data-preset')) {
      var box = t.closest('[data-sizing]');
      var input = box && box.querySelector('[data-area]');
      if (input) { input.value = t.getAttribute('data-preset'); updateSizing(box); }
      return;
    }
    t.setAttribute('aria-pressed', String(t.getAttribute('aria-pressed') !== 'true'));
    if (t.hasAttribute('data-add')) updateList();
  });
  document.addEventListener('input', function (ev) {
    var box = ev.target.closest('[data-sizing]');
    if (box && ev.target.hasAttribute('data-area')) updateSizing(box);
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var open = document.querySelector('[data-mega-item].is-open');
    if (open) { setMega(open, false); open.querySelector('[data-mega-toggle]').focus(); return; }   // сначала закрывается панель меню
    each('[data-nav-toggle][aria-expanded="true"]', function (b) { b.click(); b.focus(); });
  });

  /* --- Выпадающие меню шапки (окно 4f): пункт [data-mega-item] = ссылка + кнопка [data-mega-toggle] + панель [data-mega].
         Кнопка раскрывает панель (aria-expanded); на компьютере с мышью — ещё и наведение с небольшой задержкой.
         Esc закрывает и возвращает фокус на кнопку; щелчок вне меню и уход фокуса из пункта (на компьютере) закрывают.
         На телефоне это аккордеон внутри выдвижного меню. Без скрипта панели скрыты, ссылки пунктов ведут на общие страницы. --- */
  var desk = window.matchMedia('(min-width: 941px)');
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function setMega(item, open) {
    var btn = item.querySelector('[data-mega-toggle]');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  function closeMegas(except) {
    each('[data-mega-item].is-open', function (i) { if (i !== except) setMega(i, false); });
  }
  each('[data-mega-item]', function (item) {
    var timer = null;
    var later = function (fn, ms) { clearTimeout(timer); timer = setTimeout(fn, ms); };
    item.addEventListener('mouseenter', function () {
      if (!desk.matches || !hover.matches) return;
      later(function () { closeMegas(item); setMega(item, true); }, document.querySelector('[data-mega-item].is-open') ? 0 : 90);
    });
    item.addEventListener('mouseleave', function () {
      if (!desk.matches || !hover.matches) return;
      later(function () { setMega(item, false); }, 220);
    });
    item.addEventListener('focusout', function (ev) {
      if (desk.matches && ev.relatedTarget && !item.contains(ev.relatedTarget)) setMega(item, false);
    });
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-mega-toggle]');
    if (btn) {
      var item = btn.closest('[data-mega-item]');
      var open = !item.classList.contains('is-open');
      closeMegas(item);
      setMega(item, open);
      return;
    }
    if (!ev.target.closest('[data-mega]')) closeMegas(null);
    if (ev.target.closest('[data-nav-toggle]')) closeMegas(null);   // меню телефона закрыли или открыли: панели свёрнуты
  });
  if (desk.addEventListener) desk.addEventListener('change', function () { closeMegas(null); });

  if (document.querySelector('[data-set-lang]')) {      // только в макете: в Shopify язык страницы задаёт сама платформа
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) { /* нет доступа: остаётся французский */ }
    var asked = new URLSearchParams(location.search).get('lang');
    var ok = function (v) { return v === 'fr' || v === 'en'; };
    setLang(ok(asked) ? asked : ok(saved) ? saved : 'fr', false);
    var menu = new URLSearchParams(location.search).get('menu');   // только макет: вариант меню для показа владельцу (?menu=compact)
    if (menu) root.setAttribute('data-menu', menu);
  } else {
    each('[data-sizing]', updateSizing);
  }
  updateList();

  /* --- Живые рисунки: анимация идёт, только пока рисунок виден. Анимация внутри SVG пересчитывается браузером на каждом кадре,
     поэтому за пределами экрана (и в скрытых видах галереи) она стоит на паузе: класс is-paused, правило в c72-units.css. */
  if ('IntersectionObserver' in window) {
    var watch = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-paused', !en.isIntersecting); });
    }, { rootMargin: '120px 0px' });
    each('.c72-unit--live, .c72-hs', function (svg) { watch.observe(svg); });   // .c72-hs — сцена «Сезоны» первого экрана
  }

  /* --- Первый экран «Сезоны»: кнопка паузы (WCAG 2.2.2). Своя пауза — класс is-held, чтобы наблюдатель выше (is-paused)
     не запускал ролик снова, когда сцена вернётся на экран. Правила — в c72-hero.css. */
  each('[data-hero-pause]', function (b) {
    b.addEventListener('click', function () {
      var held = b.getAttribute('aria-pressed') !== 'true';
      var scene = b.closest('.c72-hs');
      b.setAttribute('aria-pressed', String(held));
      if (scene) scene.classList.toggle('is-held', held);
    });
  });
})();
